<template>
  <v-app>
    <div>5問中{{ correct }}問正解！</div>
    <div>
      <v-row>
        <v-col>
          <v-btn
            @click="
              () => {
                jumpTwitter();
              }
            "
            class="btn"
            >ツイートする</v-btn
          >
        </v-col>
        <v-col>
          <v-btn
            @click="
              () => {
                replay();
              }
            "
            class="btn"
            >もう一度プレイ</v-btn
          >
        </v-col>
      </v-row>
    </div>
    <template>
      <v-data-table
        :headers="headers"
        disable-filtering
        disable-sort
        hide-default-footer
        :items="this.returnStartPageThis.result"
      >
        <template v-slot:item.i="{ item }">
          <span>
            {{ item.i }}
          </span>
        </template>
        <template v-slot:item.m_ResouceBaseName="{ item }">
          <span>
            <v-btn
              outlined
              color="indigo"
              @click="
                () => {
                  playVoice(item.m_ResouceBaseName);
                }
              "
            >
              <v-icon dark left> mdi-play </v-icon> play
            </v-btn>
          </span>
        </template>
        <template v-slot:item.answer="{ item }">
          <span>
            {{ item.answer }}
          </span>
        </template>
        <template v-slot:item.primaryCharacterID="{ item }">
          <span>
            <img
              style="height: 80px"
              :src="
                `https://mergedcharaicon-asset.kirafan.cn/charaicon_${item.primaryCharacterID}.png`
              "
            />
          </span>
        </template>
      </v-data-table>
    </template>
  </v-app>
</template>

<style scoped>
.btn {
  width: 100%;
}
</style>

<script>
export default {
  props: ["result", "returnStartPageThis"],
  data() {
    return {
      headers: [
        { text: "n問目", value: "i" },
        { text: "アイコン", value: "primaryCharacterID" },
        { text: "play", value: "m_ResouceBaseName" },

        { text: "問題", value: "m_FullName" },
        { text: "回答", value: "answer" },
      ],
    };
  },
  computed: {
    correct() {
      return this.returnStartPageThis.result.filter((x) => x.correct).length;
    },
  },
  methods: {
    jumpTwitter() {
      let url = new URL("https://twitter.com/intent/tweet");
      let text = `#きらファンボイスクイズ で5問中${this.correct}問正解しました！\n`;

      this.returnStartPageThis.result.forEach((item) => {
        text += `\n${item.correct ? "⭕" : "❌"} ${item.i}問目: ${
          item.m_FullName
        }`;
      });
      text += `\n\nhttps://kirafan-voice-quiz.y52.dev/`;

      url.searchParams.set("text", text);

      window.open(url, "_blank");
    },
    replay() {
      // returnStartPageThis.
      this.returnStartPageThis.mode = this.returnStartPageThis.modeList.main;
    },
    playVoice(resouceBaseName) {
      this.returnStartPageThis.play(resouceBaseName);
    },
  },
};
</script>
